import momentWithLocales from '../localization/moment';

export default function configMoment() {
  // extending moment.duration to support .format()
  const momentDurationFormatSetup = require('moment-duration-format');
  momentDurationFormatSetup(momentWithLocales);
}
